import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PropertyCard from "@/components/app/PropertyCard";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Properties() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/properties").then(({ data }) => setList(data)).finally(() => setLoading(false));
  }, []);

  const filtered = list.filter(
    (p) =>
      p.name.toLowerCase().includes(q.toLowerCase()) ||
      p.location.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="overline">Marketplace</div>
          <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-white mt-2">
            Properties
          </h1>
        </div>
        <div className="relative w-full max-w-xs">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
          <Input
            data-testid="properties-search"
            placeholder="Search by name or location"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="pl-9 bg-[#050914] border-white/10 text-white focus:border-[#D4AF37]"
          />
        </div>
      </div>
      {loading ? (
        <div className="text-gray-500">Loading...</div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-20 text-gray-500">No properties found</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((p, i) => (
            <PropertyCard key={p.id} p={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
